function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

import { PREFIX as t, OBJECT as e, UNDEFINED as r } from "@analytics/type-utils";
var n = "global",
    o = t + n + t,
    l = (typeof self === "undefined" ? "undefined" : _typeof(self)) === e && self.self === self && self || (typeof global === "undefined" ? "undefined" : _typeof(global)) === e && global[n] === global && global || void 0;

function f(t) {
  return l[o][t];
}

function a(t, e) {
  return l[o][t] = e;
}

function i(t) {
  delete l[o][t];
}

function u(t, e, r) {
  var n;

  try {
    if (s(t)) {
      var o = window[t];
      n = o[e].bind(o);
    }
  } catch (t) {}

  return n || r;
}

l[o] || (l[o] = {});
var c = {};

function s(t) {
  if (_typeof(c[t]) !== r) return c[t];

  try {
    var e = window[t];
    e.setItem(r, r), e.removeItem(r);
  } catch (e) {
    return c[t] = !1;
  }

  return c[t] = !0;
}

export { n as GLOBAL, o as KEY, f as get, l as globalContext, s as hasSupport, i as remove, a as set, u as wrap };